"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateIsOneOf = exports.validateIsType = exports.validateIsArray = exports.validateIsNotNegativeInteger = exports.validateIsInteger = exports.validateIsNotEmptyString = exports.validateIsString = exports.validateIsNotNullOrUndefined = void 0;

var ValidationError_1 = __importDefault(require("../errors/ValidationError"));

function validateIsNotNullOrUndefined(varName, varValue) {
  if (varValue === undefined) {
    throw new ValidationError_1.default("Expected ".concat(varName, " to not be undefined."));
  }

  if (varValue == null) {
    throw new ValidationError_1.default("Expected ".concat(varName, " to not be null."));
  }
}

exports.validateIsNotNullOrUndefined = validateIsNotNullOrUndefined;

function validateIsString(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (allowNull && varValue == null) {
    return;
  }

  validateIsNotNullOrUndefined(varName, varValue);

  if (typeof varValue !== 'string' && !(varValue instanceof String)) {
    throw new ValidationError_1.default("Expected ".concat(varName, " to be a string but was a ").concat(typeof varValue, " (").concat(varValue, ")."));
  }
}

exports.validateIsString = validateIsString;

function validateIsNotEmptyString(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (allowNull && varValue == null) {
    return;
  }

  validateIsString(varName, varValue);

  if (varValue.length === 0) {
    throw new ValidationError_1.default("Expected ".concat(varName, " to not be an empty string."));
  }
}

exports.validateIsNotEmptyString = validateIsNotEmptyString;

function validateIsInteger(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (allowNull && varValue == null) {
    return;
  }

  validateIsNotNullOrUndefined(varName, varValue);

  if (!Number.isInteger(varValue)) {
    throw new ValidationError_1.default("Expected ".concat(varName, " to be an integer but was a ").concat(typeof varValue, " (").concat(varValue, ")."));
  }
}

exports.validateIsInteger = validateIsInteger;

function validateIsNotNegativeInteger(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (allowNull && varValue == null) {
    return;
  }

  validateIsInteger(varName, varValue);

  if (varValue < 0) {
    throw new ValidationError_1.default("Expected ".concat(varName, " to not be negative (").concat(varValue, ")."));
  }
}

exports.validateIsNotNegativeInteger = validateIsNotNegativeInteger;

function validateIsArray(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (allowNull && varValue == null) {
    return;
  }

  validateIsNotNullOrUndefined(varName, varValue);

  if (!Array.isArray(varValue)) {
    throw new ValidationError_1.default("Expected ".concat(varName, " to be an array but was a ").concat(typeof varValue, " (").concat(varValue, ")."));
  }
}

exports.validateIsArray = validateIsArray;

function validateIsType(varName, varValue, typeName, typeClass) {
  var allowNull = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (allowNull && varValue == null) {
    return;
  }

  if (!(varValue instanceof typeClass)) {
    var msg = "Expected ".concat(varName, " to be an instance of (").concat(typeName, "), but it was: ").concat(JSON.stringify(varValue));
    throw new ValidationError_1.default(msg);
  }
}

exports.validateIsType = validateIsType;

function validateIsOneOf(varName, varValue, validValues) {
  var allowNull = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (allowNull && varValue == null) {
    return;
  }

  validateIsNotNullOrUndefined(varName, varValue);

  if (!validValues.includes(varValue)) {
    var msg = "Expected ".concat(varName, " to be one of ").concat(JSON.stringify(validValues), " but was (").concat(varValue, ").");
    throw new ValidationError_1.default(msg);
  }
}

exports.validateIsOneOf = validateIsOneOf;